import React from 'react';
import styled from 'styled-components';
import { renderContent } from 'utilities/content/content-utilities';
import { sendAnalyticsEvent } from 'utilities/creditOffers/creditOfferUtilities';
import { PriceTerm } from 'types/Product';
import { gridConfig } from '@tvg/fuse-design';
import Button from 'components/Button/Button';
import YouCouldPayOptions from './content/littlewoods/YouCouldPayOptions';
import YouCouldPayInformation from './content/littlewoods/YouCouldPayInformation';
import { Dialog } from './styles/DialogStyles';

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledButton = styled(Button)`
  width: 100%;

  @media (min-width: ${gridConfig.m.minWidth}) {
    width: auto;
  }
`;

type Props = {
  open: boolean;
  priceTerms?: PriceTerm[];
  productName: string;
  longestWeeklyPriceTermWithInterest?: PriceTerm;
  longestWeeklyPriceTermWithZeroInterest?: PriceTerm;
  selectedSkuPrice?: string;
  showBNPL?: boolean;
  onClose: () => void;
};

function YouCouldPayDialog(props: Props) {
  const {
    open,
    priceTerms,
    productName,
    longestWeeklyPriceTermWithInterest,
    longestWeeklyPriceTermWithZeroInterest,
    selectedSkuPrice,
    showBNPL,
    onClose,
  } = props;

  const handleOnClose = () => {
    onClose();
    sendAnalyticsEvent({
      gaLabel: 'Close dialog',
    });
  };

  return (
    <Dialog
      open={open}
      srLabelCloseButton="Close"
      title={renderContent('littlewoods.dialog.heading.default')}
      zIndex="20"
      onClose={handleOnClose}
    >
      {!selectedSkuPrice ? (
        <YouCouldPayInformation />
      ) : (
        <YouCouldPayOptions
          longestWeeklyPriceTermWithInterest={longestWeeklyPriceTermWithInterest}
          longestWeeklyPriceTermWithZeroInterest={longestWeeklyPriceTermWithZeroInterest}
          priceTerms={priceTerms}
          productName={productName}
          showBNPL={!!showBNPL}
          skuPrice={selectedSkuPrice}
        />
      )}

      <ButtonContainer>
        <StyledButton data-testid="close-dialog-button" variant="tertiary" onClick={handleOnClose}>
          Close
        </StyledButton>
      </ButtonContainer>
    </Dialog>
  );
}
export default YouCouldPayDialog;
